import { type ResearchAccess } from "../types";

/** 最寄駅の表示（例: 錦川清流線 守内かさ神駅 徒歩100分（対象住所の位置から判定）） */
export const formatAccessStation = (access: ResearchAccess): string => {
  const line = access.lineName ? `${access.lineName} ` : "";
  // 地番の土地が見つからず、対象住所の位置で測ったときは、そのことを添える
  const basis = access.basis === "address" ? "（対象住所の位置から判定）" : "";
  return `${line}${access.stationName}駅 徒歩${access.onFoot ?? "-"}分${basis}`;
};

/** 僻地加算・車両必須加算が、直線距離から自動で判定した目安であることの説明 */
export const buildAccessDisclaimer = (access: ResearchAccess): string =>
  [
    "僻地加算・車両必須加算は、最寄駅までの直線距離から自動で判定した目安です。",
    access.basis === "address"
      ? "地番の土地が見つからなかったため、対象住所の位置から判定しました。"
      : "",
    "現地までの道のりや交通の事情によっては、運営が確認したうえで加算を変更する場合があります。",
  ].join("");
